export enum AuthProviders {
  AUTH0 = 'auth0', // eslint-disable-line
  COGNITO = 'cognito', // eslint-disable-line
  CUSTOM = 'custom', // eslint-disable-line
}

// Get the current authentication provider from environment variables
export const getCurrentAuthProvider = (): AuthProviders => {
  const provider = process.env.REACT_APP_AUTH_PROVIDER?.toLowerCase();

  switch (provider) {
    case 'auth0':
      return AuthProviders.AUTH0;
    case 'cognito':
      return AuthProviders.COGNITO;
    case 'custom':
      return AuthProviders.CUSTOM;
    default:
      return AuthProviders.AUTH0; // Default to Auth0
  }
};

// Check if custom authentication is enabled
export const isCustomAuthEnabled = (): boolean =>
  getCurrentAuthProvider() === AuthProviders.CUSTOM;

// Check if Cognito authentication is enabled
export const isCognitoAuthEnabled = (): boolean =>
  getCurrentAuthProvider() === AuthProviders.COGNITO;

// Check if Auth0 authentication is enabled
export const isAuth0Enabled = (): boolean =>
  getCurrentAuthProvider() === AuthProviders.AUTH0;
